import { defineComponent, h } from 'vue';
import utils from '../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';
import { marked } from 'marked';
import './schemaform/formMarkdownEditor.css';

export default defineComponent({
    name: 'Markdown',
    mixins: [
        BaseComponent,
    ],
    data: function () {
        return {
            colorEval: null,
            fontSizeEval: null,
            cssClassEval: null,
            markdownEval: null,
        }
    },
    computed: {
        fontSize() {
            try {
                if (this.fontSizeEval === null && this.controlData.FontSize)
                    this.fontSizeEval = utils.compile(this, this.controlData.FontSize);
                if (this.fontSizeEval)
                    return utils.resolveFontSize(utils.evaluate(this.fontSizeEval, this));
                return '';
            }
            catch (e) {
                utils.warn('Font size could not evaluate expression: ' + this.controlData.FontSize + '; ' + e);
                return '14px';
            }
        },
        color() {
            try {
                if (this.colorEval === null && this.controlData.Color)
                    this.colorEval = utils.compile(this, this.controlData.Color);
                if (this.colorEval)
                    return utils.evaluate(this.colorEval, this);
                return '';
            }
            catch (e) {
                utils.warn('Color could not evaluate expression: ' + this.controlData.Color + '; ' + e);
                return '#444';
            }
        },
        cssClasses() {
            try {
                let classes = {};
                if (this.cssClassEval === null && this.controlData.CssClass)
                    this.cssClassEval = utils.compile(this, this.controlData.CssClass);
                if (this.cssClassEval) {
                    const value = utils.evaluate(this.cssClassEval, this);
                    value?.split(' ')?.forEach(item => {
                        if (item)
                            classes[item] = true;
                    });
                }
                return classes;
            }
            catch (e) {
                utils.warn('CssClasses could not evaluate expression: ' + this.controlData.CssClass + '; ' + e);
                return {};
            }
        },
        customClasses() {
            let classes = { 'c-Markdown': true, [`c-name-${this.name || 'unnamed'}`]: true };

            if (this.styleHints && this.styleHints.CustomClasses) {
                let customClasses = utils.resolveCustomClasses(this.styleHints, this);
                if (customClasses) {
                    customClasses = customClasses.split(' ');
                    for (let i = 0; i < customClasses.length; i++) {
                        classes[customClasses[i]] = true;
                    }
                }
            }

            return classes;
        },
        textStyles() {
            let styles = {};

            if (this.fontSize)
                styles['font-size'] = this.fontSize;

            if (this.color)
                styles.color = this.color;

            return {
                ...utils.resolveStyleHints(this.styleHints, this),
                ...styles,
                overflow: 'visible',
                whiteSpace: 'normal',
                display: 'block',
            };
        },
        size() {
            return { ...this.sizeStyle, display: 'flex', flexDirection: 'column' };
        },
        markdownHtml() {
            if (!this.controlData?.Markdown)
                return '';

            try {
                let raw;
                if (!this.controlData.EnableInterpolation) {
                    raw = String(this.controlData.Markdown ?? '');
                }
                else {
                    if (this.markdownEval === null)
                        this.markdownEval = utils.compile(this, this.controlData.Markdown);

                    if (!this.markdownEval)
                        return '';

                    const res = utils.evaluate(this.markdownEval, this);
                    raw = String(res ?? '');
                }

                if (!raw)
                    return '';

                return marked.parse(raw, { async: false, gfm: true, breaks: true });
            }
            catch (e) {
                utils.warn('Markdown markdownHtml (marked) failed: ' + e);
                return '';
            }
        },
    },
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
        async onMarkdownClick(e) {
            const anchor = e.target?.closest?.('a[href]');
            if (!anchor)
                return;

            if (!this.controlData.Actions?.length)
                return;

            e.preventDefault();
            e.stopPropagation();

            await utils.executeAndCompileAllActions(
                this.controlData.Actions,
                {
                    Href: anchor.getAttribute('href') || '',
                    Text: anchor.textContent || '',
                    Title: anchor.getAttribute('title') || '',
                },
                this
            );
        },
    },
    props: {
    },
    render() {
        try {
            if (!this.todisplay)
                return null;

            return (
                <div
                    class={this.customClasses}
                    style={this.size}
                    v-show={this.isvisible}
                    onClick={(e) => this.onMarkdownClick(e)}
                >
                    <div
                        class={['form-markdown-editor-prose', 'tiptap', this.cssClasses]}
                        style={this.textStyles}
                        v-html={this.markdownHtml}
                    />
                </div>
            );
        }
        catch (e) {
            utils.error('Markdown Render failed', e);
            return <div>Markdown Failed to Render {e}</div>;
        }
    }
});
